var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 py-1 d-inline-flex align-items-center",style:({'background-color': `${_vm.miniformat.background_color} !important`}),attrs:{"miniformat-badge-component":""}},[(_vm.miniformat.icon)?_c('div',{staticClass:"mr-1",class:_vm.miniformat.icon}):_vm._e(),_vm._v(_vm._s(_vm.miniformat.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }